import {
  BATCH_EDIT_SITE_ALARM_OPTIONS,
  CREATE_SITE_ALARM_OPTION,
  DELETE_SITE_ALARM_OPTION,
  EDIT_SITE_ALARM_OPTION,
  RECEIVE_SITE_ALARM_OPTIONS,
  REQUEST_SITE_ALARM_OPTION,
  REQUEST_SITE_ALARM_OPTIONS_FOR_SITE,
} from '@sophocles/entities/SiteAlarmOption/siteAlarmOptionActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_SITE_ALARM_OPTIONS: // Read
      return action.siteAlarmOptions;
    case DELETE_SITE_ALARM_OPTION: // Delete
      return state.delete(action.siteAlarmOption.toString());
    case EDIT_SITE_ALARM_OPTION: // Update
    case CREATE_SITE_ALARM_OPTION: // Create
    case REQUEST_SITE_ALARM_OPTION:
    case REQUEST_SITE_ALARM_OPTIONS_FOR_SITE:
    case BATCH_EDIT_SITE_ALARM_OPTIONS:
    default:
      return state;
  }
}

export function siteAlarmOptionReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_SITE_ALARM_OPTION:
    case DELETE_SITE_ALARM_OPTION:
    case RECEIVE_SITE_ALARM_OPTIONS:
    case EDIT_SITE_ALARM_OPTION:
    case REQUEST_SITE_ALARM_OPTION:
    case REQUEST_SITE_ALARM_OPTIONS_FOR_SITE:
    case BATCH_EDIT_SITE_ALARM_OPTIONS:
      return getState(state, action);
    default:
      return state;
  }
}
